import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useHideContent = () => {
  const createHiddenContent = useCallback(({ contentId, classroomId }) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify({
        content_id: contentId,
        classroom_id: classroomId,
      }),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(
      `${MONOLITH_ORIGIN}/api/v3/content-hide/`,
      requestParams,
    );
  }, []);
  return useRestMutation(createHiddenContent);
};

export default useHideContent;
